import { getBalanceReport } from '_services/reportService/reportService'
import { CommonDateRange } from 'components'
import { utils } from 'helper'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { BsDownload, BsPencil } from 'react-icons/bs'
import { FaCaretDown, FaPrint } from 'react-icons/fa6'
import { FiRefreshCcw } from 'react-icons/fi'
import { IoSettingsOutline } from 'react-icons/io5'
import StorageService from 'utils/StorageServices/StorageServices'
import '../reports.css'

const BalanceSheet = () => { 

    const [balanceSheetData, setBalanceSheetData] = useState({});
    const [loading, setLoading] = useState(false);
    const currentDate = new Date();
    const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const [selectedRange, setSelectedRange] = useState({
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
    });

    const handleApply = (newRange) => {
        setSelectedRange(newRange);
    };

    useEffect(() => {
        getBalanceSheetList()
    }, [selectedRange])

    const getBalanceSheetList = async () => {
        setLoading(true)
        const payload = {
            company_id: StorageService.getCompanyId(),
            start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
            end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        }
        try {
            const res = await getBalanceReport(payload);
            if (res?.responseCode == 200) {
                setBalanceSheetData(res?.data)
                setLoading(false)
            } else {
                setLoading(false)
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const resetFunction = () => {
        const newStartDate = moment().startOf('month');
        const newEndDate = moment().endOf('month');

        setSelectedRange({
            startDate: newStartDate,
            endDate: newEndDate,
        });
    };

    return (
        <>
            <div className='__znDe_mainBx'>
                <div>
                    <div className='panel-heading'>
                        <h2><span>Balance Sheet</span></h2>

                        <div className='panel-ctrls report-control'>
                            <div>
                                <CommonDateRange
                                    key={`${selectedRange.startDate}-${selectedRange.endDate}`}
                                    initialStartDate={selectedRange.startDate}
                                    initialEndDate={selectedRange.endDate}
                                    onApply={handleApply}
                                />
                            </div>

                            <button className='__bxs_srBtn'>
                                <BsDownload />
                            </button>


                            <button className='__bxs_srBtn' onClick={(e) => resetFunction(e)}>
                                <FiRefreshCcw />
                            </button>
                        </div>

                        {/* <div className='panel-ctrls report-control'>
                            <div class="dropdown">
                                <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                This Year 
                                <FaCaretDown />
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="#">Action</a></li>
                                    <li><a class="dropdown-item" href="#">Another action</a></li>
                                    <li><a class="dropdown-item" href="#">Something else here</a></li>
                                </ul>
                            </div>

                            <button className='__bxs_srBtn'>
                            <IoSettingsOutline />
                            </button>

                            <button className='__bxs_srBtn'>
                            <BsDownload />
                            </button>

                            <button className='__bxs_srBtn'>
                            <FaPrint />
                            </button>

                            <button className='__bxs_srBtn'>
                            <BsPencil />
                            </button>

                            <button className='__bxs_srBtn'>
                            <FiRefreshCcw />
                            </button>
                        </div> */}
                    </div>
                </div>

                <div className='__hrlMain_dix'>
                    <div className='voucher report-voucher  printable'>
                        <div className='__mainPanel'>
                            <div className="panel panel-primary">
                                <div className='panel-body '>
                                    <div className='py-20 block-ui block-ui-anim-fade'>
                                        <div className='clear-both text-center p-10'>
                                            <div class="__hrlMx_head" >
                                                <p>{balanceSheetData?.company?.company ? balanceSheetData?.company?.company : '-'}</p>
                                                <h4>Balance Sheet</h4>
                                                <h5><span>Basis</span> : Accrual</h5>
                                                <h5>As of {balanceSheetData?.start_date ? utils.getDateByApiResponse(balanceSheetData?.start_date) : ""}</h5>
                                            </div>
                                        </div>

                                       {loading ? <span className='m-5 commonCenter_avt'>Loading...</span> : <div className='clear-both'>
                                            <div className='report-table mt-15'>
                                                <div className='rpt-head'>
                                                    <div className='rpt-cell rpt-col-item1 text-left'> Assets </div>
                                                    <div className='rpt-cell rpt-col-qty1 text-end'> {balanceSheetData?.start_date ? utils.getDateByApiResponse(balanceSheetData?.start_date) : ""} </div>
                                                </div>

                                                {balanceSheetData?.Assets?.assets?.map((item, itemIndex) => {
                                                    return (
                                                        <React.Fragment key={itemIndex}>
                                                            <div className='subHead'>
                                                                <div className='highlight-row'>
                                                                    <div className='rpt-cell rpt-col-item1 text-left'>{item?.name}</div>
                                                                    <div className='rpt-cell rpt-col-qty1 text-end'>&nbsp;</div>
                                                                </div>
                                                                {item?.accounts?.map((el, idx) => {
                                                                    return (
                                                                        <React.Fragment key={idx}>
                                                                            <div className='rw-btm-border clickable-row'>
                                                                                <div className='rpt-cell rpt-col-item1 pl-30'>{el?.name ? el?.name : '-'}</div>
                                                                                <div className='rpt-cell rpt-col-qty1 text-end'>{el?.balance ? el?.balance : 0}</div>
                                                                            </div>
                                                                        </React.Fragment>
                                                                    )
                                                                })}
                                                                <div className='row-total'>
                                                                    <div className='rpt-cell rpt-col-item1'>Total {item?.name}</div>
                                                                    <div className='rpt-cell rpt-col-qty1 text-end'>{item?.balance}</div>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                })}
                                                <div className='row-total'>
                                                    <div className='rpt-cell rpt-col-item1'>Total Assets</div>
                                                    <div className='rpt-cell rpt-col-qty1 text-end'>{balanceSheetData?.Assets?.total_assets ? balanceSheetData?.Assets?.total_assets : ''}</div>
                                                </div>
                                            </div>

                                            <div className='report-table mt-15'>
                                                <div className='rpt-head'>
                                                    <div className='rpt-cell rpt-col-item1 text-left'>Equity</div>
                                                    <div className='rpt-cell rpt-col-qty1 text-end'> {balanceSheetData?.start_date ? utils.getDateByApiResponse(balanceSheetData?.start_date) : ""} </div>
                                                </div>
                                                {balanceSheetData?.Equity?.equity?.map((item, itemIndex) => {
                                                    return (
                                                        <React.Fragment key={itemIndex}>
                                                            <div className='subHead'>
                                                                <div className='highlight-row'>
                                                                    <div className='rpt-cell rpt-col-item1 text-left'>{item?.name}</div>
                                                                    <div className='rpt-cell rpt-col-qty1 text-end'>&nbsp;</div>
                                                                </div>
                                                                {item?.accounts?.map((el, idx) => {
                                                                    return (
                                                                        <React.Fragment key={idx}>
                                                                            <div className='rw-btm-border clickable-row'>
                                                                                <div className='rpt-cell rpt-col-item1 pl-30'>{el?.name ? el?.name : '-'}</div>
                                                                                <div className='rpt-cell rpt-col-qty1 text-end'>{el?.balance ? el?.balance : 0}</div>
                                                                            </div>
                                                                        </React.Fragment>
                                                                    )
                                                                })}
                                                                <div className='row-total'>
                                                                    <div className='rpt-cell rpt-col-item1'>Total {item?.name}</div>
                                                                    <div className='rpt-cell rpt-col-qty1 text-end'>{item?.balance}</div>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                })}
                                                <div className='row-total'>
                                                    <div className='rpt-cell rpt-col-item1'>Total Equity</div>
                                                    <div className='rpt-cell rpt-col-qty1 text-end'> {balanceSheetData?.Equity?.total_equity ? balanceSheetData?.Equity?.total_equity : ''} </div>
                                                </div>
                                            </div>

                                            <div className='report-table mt-15'>
                                                <div className='rpt-head'>
                                                    <div className='rpt-cell rpt-col-item1 text-left'>Liability</div>
                                                    <div className='rpt-cell rpt-col-qty1 text-end'> {balanceSheetData?.start_date ? utils.getDateByApiResponse(balanceSheetData?.start_date) : ""} </div>
                                                </div>
                                                {balanceSheetData?.Liabilities?.liabilities?.map((item, itemIndex) => {
                                                    return (
                                                        <React.Fragment key={itemIndex}>
                                                            <div className='subHead'>
                                                                <div className='highlight-row'>
                                                                    <div className='rpt-cell rpt-col-item1 text-left'>{item?.name}</div>
                                                                    <div className='rpt-cell rpt-col-qty1 text-end'>&nbsp;</div>
                                                                </div>
                                                                {item?.accounts?.map((el, idx) => {
                                                                    return (
                                                                        <React.Fragment key={idx}>
                                                                            <div className='rw-btm-border clickable-row'>
                                                                                <div className='rpt-cell rpt-col-item1 pl-30'>{el?.name ? el?.name : '-'}</div>
                                                                                <div className='rpt-cell rpt-col-qty1 text-end'>{el?.balance ? el?.balance : 0}</div>
                                                                            </div>
                                                                        </React.Fragment>
                                                                    )
                                                                })}
                                                                <div className='row-total'>
                                                                    <div className='rpt-cell rpt-col-item1'>Total {item?.name}</div>
                                                                    <div className='rpt-cell rpt-col-qty1 text-end'>{item?.balance}</div>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                })}
                                                <div className='row-total'>
                                                    <div className='rpt-cell rpt-col-item1'>Total Liabilities</div>
                                                    <div className='rpt-cell rpt-col-qty1 text-end'>{balanceSheetData?.Liabilities?.total_liabilities ? balanceSheetData?.Liabilities?.total_liabilities : ''}</div>
                                                </div>
                                                <div className='report-table w-100'>
                                                    <div className='row-total'>
                                                        <div className='rpt-cell rpt-col-item1'>Total Liability & Equity</div>
                                                        <div className='rpt-cell rpt-col-qty1 text-end'>{balanceSheetData?.total_liabilities_equity ? balanceSheetData?.total_liabilities_equity : 0}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default BalanceSheet